module.exports = __webpack_public_path__ + "static/media/network-figure-01.d6dfb76f.svg";